export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/5547991891311"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-5 right-5 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-accent-500 opacity-40 animate-ping" />
      <span className="relative inline-flex items-center gap-2 rounded-full bg-accent-500 text-primary-950 px-4 py-3 shadow-lg hover:bg-background-50 transition-colors">
        <i className="ri-whatsapp-line text-xl"></i>
        <span className="hidden sm:inline text-sm font-medium whitespace-nowrap">Fale conosco</span>
      </span>
    </a>
  );
}